<template>
  <div class="admin-container">
    <!-- 登录表单 -->
    <div v-if="!isLoggedIn" class="login-form">
      <h2>管理员登录</h2>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label>用户名</label>
          <input 
            type="text" 
            v-model="loginForm.username" 
            placeholder="请输入用户名"
          >
        </div>
        <div class="form-group">
          <label>密码</label>
          <input 
            type="password" 
            v-model="loginForm.password" 
            placeholder="请输入密码"
          >
        </div>
        <button type="submit" class="login-btn">登录</button>
      </form>
    </div>

    <!-- 留言管理界面 -->
    <div v-else class="message-management">
      <div class="header">
        <h2>留言管理</h2>
        <button class="logout-btn" @click="handleLogout">退出登录</button>
      </div>
      
      <div class="message-list">
        <div v-for="(message, index) in messages" :key="index" class="message-item">
          <div class="message-header">
            <span class="name">{{ message.name }}</span>
            <span class="time">{{ formatTime(message.timestamp) }}</span>
          </div>
          <div class="message-content">
            <div class="contact-info">
              <p><span>电话：</span>{{ message.phone }}</p>
              <p><span>邮箱：</span>{{ message.email }}</p>
            </div>
            <div class="message-text">
              <p>{{ message.message }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminView',
  data() {
    return {
      isLoggedIn: false,
      loginForm: {
        username: '',
        password: ''
      },
      messages: []
    }
  },
  methods: {
    handleLogin() {
      if (this.loginForm.username === 'zrm888' && this.loginForm.password === 'zrm888') {
        this.isLoggedIn = true;
        this.fetchMessages();
      } else {
        alert('用户名或密码错误');
      }
    },
    handleLogout() {
      this.isLoggedIn = false;
      this.loginForm = {
        username: '',
        password: ''
      };
      this.messages = [];
    },
    async fetchMessages() {
      try {
        const response = await fetch('/api/getmessage');
        const data = await response.json();
        if (data.success) {
          // 按时间从新到旧排序
          this.messages = data.data.sort((a, b) => {
            return new Date(b.timestamp) - new Date(a.timestamp);
          });
        }
      } catch (error) {
        console.error('获取留言失败:', error);
        alert('获取留言失败，请稍后重试');
      }
    },
    formatTime(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    }
  }
}
</script>

<style lang="less" scoped>
.admin-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #0a0a0a 100%);
  padding: 20px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><rect width="100" height="100" fill="none"/><path d="M0,0 L100,100 M100,0 L0,100" stroke="rgba(255,255,255,0.05)" stroke-width="1"/></svg>');
    opacity: 0.1;
    z-index: 0;
  }
}

.login-form {
  max-width: 400px;
  margin: 100px auto;
  padding: 40px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  position: relative;
  z-index: 1;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);

  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(45deg, #ff0000, #ff0000, #ff0000, #ff0000);
    z-index: -1;
    border-radius: 10px;
    opacity: 0.1;
  }

  h2 {
    text-align: center;
    color: #fff;
    margin-bottom: 30px;
    font-size: 24px;
    letter-spacing: 2px;
    text-transform: uppercase;
    text-shadow: 0 0 10px rgba(255, 0, 0, 0.5);
  }

  .form-group {
    margin-bottom: 25px;

    label {
      display: block;
      margin-bottom: 8px;
      color: #fff;
      font-size: 14px;
      letter-spacing: 1px;
    }

    input {
      width: 100%;
      padding: 12px;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 4px;
      font-size: 14px;
      color: #fff;
      transition: all 0.3s;
      box-sizing: border-box;

      &::placeholder {
        color: rgba(255, 255, 255, 0.5);
      }

      &:focus {
        outline: none;
        border-color: #ff0000;
        box-shadow: 0 0 10px rgba(255, 0, 0, 0.3);
      }
    }
  }

  .login-btn {
    width: 100%;
    padding: 12px;
    background: linear-gradient(45deg, #ff0000, #c7000b);
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
    cursor: pointer;
    transition: all 0.3s;
    text-transform: uppercase;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
      transition: 0.5s;
    }

    &:hover {
      background: linear-gradient(45deg, #c7000b, #ff0000);
      box-shadow: 0 0 15px rgba(255, 0, 0, 0.5);

      &::before {
        left: 100%;
      }
    }
  }
}

.message-management {
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  z-index: 1;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding: 20px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);

    &::before {
      content: '';
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      background: linear-gradient(45deg, #ff0000, #ff0000, #ff0000, #ff0000);
      z-index: -1;
      border-radius: 10px;
      opacity: 0.1;
    }

    h2 {
      color: #fff;
      margin: 0;
      text-shadow: 0 0 10px rgba(255, 0, 0, 0.5);
      font-size: 24px;
      letter-spacing: 2px;
      text-transform: uppercase;
    }

    .logout-btn {
      padding: 12px 24px;
      background: linear-gradient(45deg, #ff0000, #c7000b);
      color: #fff;
      border: none;
      border-radius: 4px;
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 1px;
      cursor: pointer;
      transition: all 0.3s;
      text-transform: uppercase;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        transition: 0.5s;
      }

      &:hover {
        background: linear-gradient(45deg, #c7000b, #ff0000);
        box-shadow: 0 0 15px rgba(255, 0, 0, 0.5);

        &::before {
          left: 100%;
        }
      }
    }
  }

  .message-list {
    .message-item {
      background: rgba(0, 0, 0, 0.7);
      border-radius: 8px;
      padding: 20px;
      margin-bottom: 20px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      transition: all 0.3s;
      backdrop-filter: blur(10px);
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: linear-gradient(45deg, #ff0000, #ff0000, #ff0000, #ff0000);
        z-index: -1;
        border-radius: 10px;
        opacity: 0.1;
      }

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
      }

      .message-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        padding-bottom: 10px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        .name {
          font-size: 16px;
          font-weight: bold;
          color: #fff;
          text-shadow: 0 0 10px rgba(255, 0, 0, 0.5);
        }

        .time {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
        }
      }

      .message-content {
        .contact-info {
          margin-bottom: 15px;

          p {
            margin: 5px 0;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.8);

            span {
              color: rgba(255, 255, 255, 0.5);
              margin-right: 10px;
            }
          }
        }

        .message-text {
          p {
            margin: 0;
            font-size: 14px;
            line-height: 1.6;
            color: #fff;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .admin-container {
    padding: 15px;
  }

  .login-form {
    margin: 50px auto;
    padding: 20px;
  }

  .message-management {
    .header {
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;

      .logout-btn {
        width: 100%;
      }
    }

    .message-item {
      padding: 15px;

      .message-header {
        flex-direction: column;
        gap: 5px;
      }
    }
  }
}
</style> 